import React from 'react';
import SmallDialog from '../lib/dialog/SmallDialog';
import { useNavigate } from 'react-router-dom';
import { Project } from '../pages/Gallery';
import Button from '../lib/button/Button';
import { useWorkspaceStore } from '../store/workspace';

export default function UseTemplateProjectDialog({
	project,
	onProjectCreate,
}: {
	project: Project;
	onProjectCreate: (newProjectId: string) => void;
}) {
	const navigate = useNavigate();

	const coverURL = project?.media?.find((media) => media.type === 'cover')
		?.url;

	const activeWorkspace = useWorkspaceStore((state) => state.activeWorkspace);

	return (
		<SmallDialog
			overlayStyle={{ zIndex: 2 }}
			style={{
				width: '500px',
				minHeight: 'auto',
				display: 'flex',
				flexDirection: 'column',
				padding: 0,
			}}
			onClose={() => navigate(`/ws/${activeWorkspace?.slug}/gallery`)}
		>
			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					height: '100%',
					justifyContent: 'space-between',
					flex: 1,
				}}
			>
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						flex: 1,
						minHeight: 0,
					}}
				>
					<div
						style={{
							// Padding left and right 30px to match the button's padding
							padding: '30px 30px 0 30px',
							display: 'flex',
							flexDirection: 'column',
							flex: 1,
							minHeight: 0,
						}}
					>
						<div
							style={{
								display: 'flex',
								alignItems: 'center',
								marginBottom: '10px',
							}}
						>
							<button
								className='dialog_back_button'
								onClick={() => navigate(`/ws/${activeWorkspace?.slug}/gallery`)}
							>
								<i className='fa-solid fa-arrow-left' />
							</button>
							<h2
								style={{
									margin: 0,
									fontWeight: 500,
									width: '100%',
									textAlign: 'center',
									marginRight: '26px',
									color: 'rgb(0, 0, 0, 0.7)',
								}}
							>
								Use this template
							</h2>
						</div>

						<div
							style={{
								display: 'flex',
								gap: 10,
								alignItems: 'center',
								marginBottom: 10,
							}}
						>
							<h1
								style={{
									margin: 0,
									width: '100%',
									textAlign: 'center',
								}}
							>
								{project?.name}
							</h1>
						</div>
					</div>

					{!!coverURL && (
						<div
							style={{
								display: 'flex',
								flexDirection: 'column',
								gap: 10,
								alignItems: 'center',
								// marginBottom: 10,
							}}
						>
							{/* Icon */}
							<img
								src={coverURL}
								alt={
									'Cover image for ' + (project?.name || 'the template project')
								}
								style={{
									width: '100%',
									maxHeight: '120px',
									objectFit: 'contain',
								}}
							/>
						</div>
					)}
					<div
						style={{
							// Padding left and right 30px to match the button's padding
							padding: '0 30px 30px 30px',
							display: 'flex',
							flexDirection: 'column',
							flex: 1,
							minHeight: 0,
						}}
					>
						{!!project?.description && (
							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									gap: 6,
									alignItems: 'center',
									marginBottom: 10,
									marginTop: !coverURL ? 30 : 5,
									overflowY: 'auto',
									maxHeight: '50vh',
									minHeight: 0,
								}}
							>
								<p
									style={{
										color: 'rgb(0, 0, 0, 0.7)',
										fontSize: 12,
										textAlign: 'center',
										margin: 0,
									}}
								>
									Description
								</p>
								<p
									style={{
										fontSize: 16,
										whiteSpace: 'pre-wrap',
										margin: 0,
									}}
								>
									{project?.description}
								</p>
							</div>
						)}
						<div style={{ flex: 1 }} />
						<Button
							onClick={() => {
								onProjectCreate(project?.id);
								navigate(`/ws/${activeWorkspace?.slug}/gallery`);
							}}
							disabled={!project}
							style={{ marginTop: 20, width: '100%' }}
						>
							Start project
						</Button>
					</div>
				</div>
			</div>
		</SmallDialog>
	);
}
